/**
 * Include your custom JavaScript here.
 */

// Widerruf-Button verstecken – prueft auch Kind-Elemente auf die Farbe #F49B00
(function () {
  'use strict';

  var ERLAUBT = ['/pages/widerruf-formular', '/pages/kontakt'];
  var pfad = window.location.pathname.replace(/\/$/, '');
  if (ERLAUBT.indexOf(pfad) !== -1) return;

  function istOrangeWiderruf(el) {
    // Farbe am Element selbst
    var bg = window.getComputedStyle(el).backgroundColor;
    if (bg === 'rgb(244, 155, 0)' || bg === 'rgba(244, 155, 0, 1)') return true;
    // Farbe in Kind-Elementen (max 30 Kinder pruefen)
    var kinder = el.querySelectorAll('*');
    for (var j = 0; j < kinder.length && j < 30; j++) {
      var kbg = window.getComputedStyle(kinder[j]).backgroundColor;
      if (kbg === 'rgb(244, 155, 0)' || kbg === 'rgba(244, 155, 0, 1)') return true;
    }
    return false;
  }

  function verstecke() {
    var alle = document.querySelectorAll('*');
    for (var i = 0; i < alle.length; i++) {
      try {
        var el = alle[i];
        if (window.getComputedStyle(el).position === 'fixed' && istOrangeWiderruf(el)) {
          el.style.setProperty('display', 'none', 'important');
        }
      } catch (e) {}
    }
  }

  if (document.readyState !== 'loading') { verstecke(); }
  else { document.addEventListener('DOMContentLoaded', verstecke); }
  setTimeout(verstecke, 300);
  setTimeout(verstecke, 1000);
  setTimeout(verstecke, 3000);

  var obs = new MutationObserver(function () { verstecke(); });
  document.addEventListener('DOMContentLoaded', function () {
    if (document.body) {
      obs.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { obs.disconnect(); }, 8000);
    }
  });
})();
